// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: structs/structs/permission.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "structs.structs";

export interface PermissionRecord {
  permissionId: string;
  value: string;
}

export interface GuildRankPermissionRecord {
  objectId: string;
  guildId: string;
  permissions: string;
  rank: string;
}

function createBasePermissionRecord(): PermissionRecord {
  return { permissionId: "", value: "0" };
}

export const PermissionRecord: MessageFns<PermissionRecord> = {
  encode(message: PermissionRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.permissionId !== "") {
      writer.uint32(10).string(message.permissionId);
    }
    if (message.value !== "0") {
      writer.uint32(16).uint64(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PermissionRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePermissionRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.permissionId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PermissionRecord {
    return {
      permissionId: isSet(object.permissionId) ? globalThis.String(object.permissionId) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "0",
    };
  },

  toJSON(message: PermissionRecord): unknown {
    const obj: any = {};
    if (message.permissionId !== "") {
      obj.permissionId = message.permissionId;
    }
    if (message.value !== "0") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PermissionRecord>, I>>(base?: I): PermissionRecord {
    return PermissionRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PermissionRecord>, I>>(object: I): PermissionRecord {
    const message = createBasePermissionRecord();
    message.permissionId = object.permissionId ?? "";
    message.value = object.value ?? "0";
    return message;
  },
};

function createBaseGuildRankPermissionRecord(): GuildRankPermissionRecord {
  return { objectId: "", guildId: "", permissions: "0", rank: "0" };
}

export const GuildRankPermissionRecord: MessageFns<GuildRankPermissionRecord> = {
  encode(message: GuildRankPermissionRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.objectId !== "") {
      writer.uint32(10).string(message.objectId);
    }
    if (message.guildId !== "") {
      writer.uint32(18).string(message.guildId);
    }
    if (message.permissions !== "0") {
      writer.uint32(24).uint64(message.permissions);
    }
    if (message.rank !== "0") {
      writer.uint32(32).uint64(message.rank);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GuildRankPermissionRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGuildRankPermissionRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.objectId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.guildId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.permissions = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.rank = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GuildRankPermissionRecord {
    return {
      objectId: isSet(object.objectId) ? globalThis.String(object.objectId) : "",
      guildId: isSet(object.guildId) ? globalThis.String(object.guildId) : "",
      permissions: isSet(object.permissions) ? globalThis.String(object.permissions) : "0",
      rank: isSet(object.rank) ? globalThis.String(object.rank) : "0",
    };
  },

  toJSON(message: GuildRankPermissionRecord): unknown {
    const obj: any = {};
    if (message.objectId !== "") {
      obj.objectId = message.objectId;
    }
    if (message.guildId !== "") {
      obj.guildId = message.guildId;
    }
    if (message.permissions !== "0") {
      obj.permissions = message.permissions;
    }
    if (message.rank !== "0") {
      obj.rank = message.rank;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GuildRankPermissionRecord>, I>>(base?: I): GuildRankPermissionRecord {
    return GuildRankPermissionRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GuildRankPermissionRecord>, I>>(object: I): GuildRankPermissionRecord {
    const message = createBaseGuildRankPermissionRecord();
    message.objectId = object.objectId ?? "";
    message.guildId = object.guildId ?? "";
    message.permissions = object.permissions ?? "0";
    message.rank = object.rank ?? "0";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
